import { createCartThunks, createCartSlice } from '@amzn/d2c-application-website-common';
import { RoadieService } from 'src/services/roadie';
import { awsRum } from 'src/rum';

const thunks = createCartThunks(
  (_stage: string, csrfToken?: string) => new RoadieService(csrfToken),
  {
    error: (message, context) => { awsRum?.recordEvent('CartError', { message, ...context }); },
    recordAPIError: (site, api, status) => { awsRum?.recordEvent('APIError', { site, api, status }); },
    recordAPIRequest: (site, api) => { awsRum?.recordEvent('APIRequest', { site, api }); },
  },
);

export const { getPreviewOrder, getConfirmOrder } = thunks;
const cartSlice = createCartSlice(thunks);
export const { replaceCartState, resetPreviewOrderState, addToCart, removeFromCart, setCart } =
  cartSlice.actions;
export default cartSlice.reducer;

export {
  selectCart,
  selectPreviewOrderInProgress,
  selectPreviewOrderComplete,
  selectConfirmOrderInProgress,
  selectConfirmOrderComplete,
  selectOrder,
  selectOrderError,
} from '@amzn/d2c-application-website-common';
